import { render, staticRenderFns } from "./DownloadAllDocuments.vue?vue&type=template&id=1471f5c8&scoped=true"
import script from "./DownloadAllDocuments.vue?vue&type=script&lang=js"
export * from "./DownloadAllDocuments.vue?vue&type=script&lang=js"
import style0 from "./DownloadAllDocuments.vue?vue&type=style&index=0&id=1471f5c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471f5c8",
  null
  
)

export default component.exports